'use client'

import Script from 'next/script'

import Canonical from '@/components/Head/Canonical'

export default function Head() {
  const baseUrl = process.env.BASE_URL || 'https://fas-jp.com/'

  // NOTE: エラーをキャッチしてBugsnagに投げると不必要なエラーが増えるためもみ消す
  const onError = () => {}
  return (
    <>
      <meta name="viewport" content="width=device-width,initial-scale=1.0,maximum-scale=1.0" />
      <Canonical baseUrl={baseUrl} />
      <Script id={'typekit'} strategy={'lazyOnload'} onError={onError}>
        {`
  (function(d) {
    var config = {
      kitId: 'zom2xtt',
      scriptTimeout: 3000,
      async: true
    },
    h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\\bwf-loading\\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
  })(document);`}
      </Script>
    </>
  )
}
